import React, { useEffect, useState } from 'react'

const CountDownTestTimer = ({ data, over, setOver }: any) => {


	const hours: any = 0
	// @ts-ignore 
	const minutes: any = 1
	const seconds: any = 0

	const [paused, setPaused] = useState(false);
	const [changes, setChanges] = useState<number>(1);

	const [[h, m, s], setTime] = useState([hours, minutes, seconds]);

	const tick = () => {
		if (paused || over) return;
		if (h === 0 && m === 0 && s === 0) setOver(true);
		else if (m === 0 && s === 0) {
			setTime([h - 1, 59, 59]);
		} else if (s === 0) {
			setTime([h, m - 1, 59]);
		} else {
			setTime([h, m, s - 1]);
		}
	};


	useEffect(() => {
		setTime([parseInt(hours), parseInt(minutes), parseInt(seconds)]);
		setPaused(false);
		setOver(false);
	}, [minutes, setOver])


	useEffect(() => {
		const timerID = setInterval(() => tick(), 1000);
		return () => clearInterval(timerID);
	});


	useEffect(() => {
		if (m.toString().padStart(1, '0') < (minutes / 2) && m.toString().padStart(1, '0') > (minutes / 4)) {
			setChanges(2)
		} else if (m.toString().padStart(1, '0') < (minutes / 2) && m.toString().padStart(1, '0') < (minutes / 4)) {
			setChanges(3)
		} else {
			setChanges(1)
		}
	}, [m, minutes])


	return (
		<div className='countdown-timer'>
			<div id="countdown">
				<div id='tiles' className={changes === 1 ? "color-full" :
					changes === 2 ? "color-half" : changes === 3 ? "color-empty" : "color-full"}>
					<span> {`${h.toString().padStart(2, '0')}:${m
						.toString()
						.padStart(2, '0')}:${s.toString().padStart(2, '0')}`} </span></div>
				<div id="left" className="countdown-label">{over ? "Time's up!" : 'Time Remaining'}</div>
			</div>
		</div>
	)
}

export default CountDownTestTimer

